/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  Provider,
} from 'react-redux';
import {
  IntlProvider,
} from 'react-intl-redux';
import Routes from './Routes';


const propTypes = {
  store: React.PropTypes.any.isRequired,
  history: React.PropTypes.any.isRequired,
};

const Root = (props) => {
  const { store, history } = props;
  return (
    <Provider store={store} key="provider">
      <IntlProvider>
        <Routes history={history} />
      </IntlProvider>
    </Provider>
  );
};

Root.propTypes = propTypes;

export default Root;




// WEBPACK FOOTER //
// ./src/containers/Root.jsx